import { SaveOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Select, Space, Tabs } from "antd";
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import { useState } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { dateCommon, validateMessages } from '../../helpers/common';
import { ThemBaoHiemThang } from '../../services/baohiem';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const ThemBaoHiem = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = useForm();
    const [isShowModal, setIsShowModal] = useState(false)
    const [loaiBaoHiemThang, setLoaiBaoHiemThang] = useState("");
    const monthFormat = ["MM/YYYY","MMYYYY"];
    const chonLoaiBaoHiemOnChange = (value: any) => {
        setLoaiBaoHiemThang(value);
    };

    const tinhBHXHThang = () => {
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                var thangNam = dateCommon.formatDate(values.thangNam.$d, "MM/yyyy");
                var data = await ThemBaoHiemThang(thangNam, values.loaiBaoHiemThang);
                navigate(Links.BaoHiem.Xem + "?id=" + data.id)
            } catch (ex: any) {
                if (values.loaiBaoHiemThang == 0) {
                    toast.error("Thêm mới không thành công! Bảo hiểm đã được khóa số liệu.");
                } else {
                    toast.error("Thêm mới không thành công! Vui lòng tính bảo hiểm tháng trước khi tính bổ sung.");
                }
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

        })
    }

    return (
        <section >
            <ContentHeader title="Bảo hiểm" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={
                                <Space>
                                    <Button
                                        type="primary"
                                        icon={<SaveOutlined rev="" />}
                                        onClick={() => { setIsShowModal(true); }}
                                    >
                                        Tạo chấm bảo hiểm
                                    </Button>
                                </Space>
                            }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: "1",
                                    label: "Bảo hiểm tháng",
                                    children:
                                        <Row>
                                            <Col span="24" className="card card-body">
                                                <Form
                                                    layout="vertical"
                                                    form={form}
                                                    validateMessages={validateMessages}
                                                    initialValues={{
                                                        'loaiBaoHiemThang': "0",
                                                        'thangNam': dayjs(),
                                                    }}
                                                >
                                                    <Row>
                                                        <Col span="12">
                                                            <Form.Item label="Loại bảo hiểm" name="loaiBaoHiemThang">
                                                                <Select onChange={chonLoaiBaoHiemOnChange}>
                                                                    <Select.Option value="0">Bảo hiểm tháng</Select.Option>
                                                                    <Select.Option value="1">Bổ sung, điều chỉnh</Select.Option>
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="12">
                                                            <Form.Item label="Tháng tính bảo hiểm" name="thangNam" className="pl-1"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Tháng tính bảo hiểm" format={monthFormat} picker="month"
                                                                />
                                                            </Form.Item>
                                                        </Col>                                                    
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                }
                            ]}
                        >
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <ModalTextForm
                show={isShowModal}
                title={"Tính bảo hiểm xã hội"}
                handleClose={() => setIsShowModal(false)}
                handleSave={() => {
                    setIsShowModal(false);
                    tinhBHXHThang();
                }}
            >
                Bạn có muốn tính bảo hiểm tháng này không
            </ModalTextForm>
        </section >
    )
}

export default ThemBaoHiem;